import React, { useState, useEffect } from "react";
import { Group } from "@mantine/core";
import ClientUpdateActionButton from "./clientUpdateActionButton";
import ClientChangeServiceRightButton from "./clientChangeServiceRightButton";
import NewTicketButton from "./newTicketButton";
import _ from "lodash";
import { useServerApi } from "../hooks/userServerApi";
import ClientStatementButton from "./clientStatementButton";
import ClientTransferCreditButton from "./clientTransferCreditButton";
import ClientRefundCreditButton from "./clientRefundCreditButton";
import ClientPolicyReviewButton from "./clientPolicyReviewButton";
import ClientProfileClosureButton from "./clientProfileClosureButton";
import { useActionRight } from "../hooks/useActionRight";
import ActionPermissionGate from "./actionPermissionGate";
import { useHideFormActionList } from "../hooks/useHideFormActionList";

const ClientActionList = ({ form, role, formAction, ...props }) => {
  const { isActionVisible } = useActionRight();
  const hideActionList = useHideFormActionList(form);
  const { code, consultants, _id } = form.values;
  const [showUpdateButton, setShowUpdateButton] = useState(false);
  const [api] = useServerApi();

  const checkClientOrder = async (id) => {
    if (!id) return;
    const result = await api.search({
      apiEntity: "order",
      searchQuery: {
        $and: [{ status: { $nin: ["DFT", "RCV"] } }, { client: id }],
      },
    });
    if (result && _.isEmpty(result.docs)) setShowUpdateButton(true);
  };

  useEffect(() => {
    if (!isActionVisible("client", "updateClient")) {
      setShowUpdateButton(false);
      return;
    }
    if (role === "CONSULTANT") {
      checkClientOrder(_id);
    } else {
      setShowUpdateButton(true);
    }
  }, [role, _id]);

  if (hideActionList) return null;

  return (
    <Group mt={10}>
      {showUpdateButton && (
        <ActionPermissionGate entity="client" action="updateClient">
          <ClientUpdateActionButton mainForm={form} />
        </ActionPermissionGate>
      )}

      <ActionPermissionGate entity="client" action="createTicket">
        <NewTicketButton
          buttonType="fullWidth"
          code={code}
          entityId={_id}
          entity="client"
          ticketType={"TK-CLIENT"}
          members={consultants?.map((c) => c?._id)}
        />
      </ActionPermissionGate>

      <ActionPermissionGate entity="client" action="changeServiceRight">
        <ClientChangeServiceRightButton color="red" mainForm={form} />
      </ActionPermissionGate>

      <ActionPermissionGate
        entity="client"
        action="statement"
        requireFullAccess={false}
      >
        <ClientStatementButton mainForm={form} />
      </ActionPermissionGate>

      <ActionPermissionGate entity="client" action="policyReview">
        <ClientPolicyReviewButton mainForm={form} />
      </ActionPermissionGate>

      <ActionPermissionGate entity="client" action="transferCredit">
        <ClientTransferCreditButton mainForm={form} />
      </ActionPermissionGate>

      <ActionPermissionGate entity="client" action="refundCredit">
        <ClientRefundCreditButton mainForm={form} />
      </ActionPermissionGate>

      <ClientProfileClosureButton mainForm={form} role={role} />
    </Group>
  );
};

export default ClientActionList;
